import { X, BookOpen } from 'lucide-react'
import { useDashboardStore } from '../../store/dashboardStore'
import { useT } from '../../hooks/useTranslation'
import { useHaptic } from '../../hooks/useHaptic'

// Компактная карточка-приветствие на Дашборде (НЕ модалка, НЕ блокирует
// приложение). Показывается один раз при первом входе, пока подсказки
// включены и юзер не админ. Закрыл(✕) — больше сама не появится, но
// подсказки остаются включёнными (тур можно запустить из настроек).
export default function WelcomeHint() {
  const t = useT()
  const haptic = useHaptic()
  const hintsIntroSeen = useDashboardStore(s => s.hintsIntroSeen)
  const hintsEnabled   = useDashboardStore(s => s.hintsEnabled)
  const setHintsIntroSeen = useDashboardStore(s => s.setHintsIntroSeen)
  const startHintsTour    = useDashboardStore(s => s.startHintsTour)
  const setActiveModal    = useDashboardStore(s => s.setActiveModal)
  const setActiveTab      = useDashboardStore(s => s.setActiveTab)
  const isAdmin           = useDashboardStore(s => s.isAdmin)
  const userBots          = useDashboardStore(s => s.userBots)

  // П.0.3 (task.txt): если у юзера УЖЕ есть бот (создан через онбординг-флоу
  // или вручную на вкладке «Боты») — карточка «Создать пробного бота» не нужна,
  // её роль выполняет TrialStatusCard.
  if (hintsIntroSeen || !hintsEnabled || isAdmin || (Array.isArray(userBots) && userBots.length > 0)) return null

  const dismiss = () => { haptic.light(); setHintsIntroSeen(true) }
  // ГЛАВНАЯ кнопка ведёт прямо к созданию пробного бота: вкладка «Боты»,
  // где для нового юзера «Добавить бота» создаёт бесплатного виртуального
  // бота сразу (без API-ключей). Карточку после этого не показываем.
  const createBot = () => { haptic.medium(); setHintsIntroSeen(true); setActiveTab('bots') }
  const start   = () => { haptic.medium(); startHintsTour() }
  const openGuide = () => { haptic.light(); setActiveModal('instruction') }

  return (
    <div
      style={{
        background: '#141414',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: 16,
        padding: '16px 18px',
        marginBottom: 16,
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{t.welcomeHintTitle}</span>
        <button
          onClick={dismiss}
          aria-label="Close"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 32, height: 32, borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)',
            border: 'none', cursor: 'pointer', flexShrink: 0,
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          <X size={16} color="#636366" />
        </button>
      </div>

      <p style={{ fontSize: 13, color: '#8E8E93', lineHeight: 1.55, margin: '0 0 14px' }}>
        {t.welcomeHintText}
      </p>

      {/* Главная кнопка — СРАЗУ к пробному боту: вкладка «Боты» → «Добавить бота» */}
      <button
        onClick={createBot}
        style={{
          width: '100%', padding: '12px', borderRadius: 12,
          background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          color: '#fff', fontSize: 14, fontWeight: 700,
          border: 'none', cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        {t.welcomeHintCreateBot}
      </button>

      {/* Второстепенные действия: тур по приложению и полная инструкция */}
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button
          onClick={start}
          style={{
            flex: 1, padding: '11px', borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
            background: 'rgba(255,255,255,0.04)',
            color: '#D0D0D5', fontSize: 13.5, fontWeight: 600,
            border: '1px solid rgba(255,255,255,0.08)', cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          {t.welcomeHintStart}
        </button>
        <button
          onClick={openGuide}
          style={{
            flex: 1, padding: '11px', borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
            background: 'rgba(255,255,255,0.04)',
            color: '#D0D0D5', fontSize: 13.5, fontWeight: 600,
            border: '1px solid rgba(255,255,255,0.08)', cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          <BookOpen size={15} color="#34D399" />
          {t.welcomeHintGuide}
        </button>
      </div>

      <p style={{ fontSize: 11.5, color: '#636366', margin: '10px 0 0', textAlign: 'center', lineHeight: 1.4 }}>
        {t.welcomeHintDismiss}
      </p>
    </div>
  )
}
